import { matchPath } from "react-router";
import parseURL from "url-parse";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
import { ROUTES } from "./Routes.constants.js";
import { ONBOARDING_DOC_TITLE } from "../constants/Onboarding.constants.js";
const matchesRootPathname = (current, target) => {
  if (!current || !target)
    return false;
  const match = matchPath(current, { path: target }) || matchPath(current, { path: `${ROUTES.studio.match.path}${target}` });
  return !!match;
};
const isPathKnownRoute = (knownRoutes, path = window.location.pathname) => {
  const { pathname } = parseURL(path);
  return knownRoutes.map((k) => k.location.pathname).includes(pathname);
};
const getPageTitle = (props) => {
  var _a, _b;
  const documentTitle = !!EnvironmentService.title ? EnvironmentService.title : ONBOARDING_DOC_TITLE;
  if (!props)
    return documentTitle;
  const { name = "", entityName = "" } = props;
  return (_b = (_a = [entityName, name, documentTitle]) == null ? void 0 : _a.reduce((value, acc) => {
    return !!value ? `${value} - ${acc}` : `${acc}`;
  })) != null ? _b : ONBOARDING_DOC_TITLE;
};
export {
  getPageTitle,
  isPathKnownRoute,
  matchesRootPathname
};
//# sourceMappingURL=Route.utils.js.map
